/* eslint-disable no-restricted-properties */
/* eslint-disable no-return-assign */
/* eslint-disable no-new */
/* eslint-disable no-underscore-dangle */
/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

// import { MONTH_NAMES } from "../../constants/Constants"

export function readCookie(name) {
  let c;

  const nameEQ = `${name}=`;
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return "";
}
export function validateEmail(email) {
  const re =
    /^(([^<>()[\]\\.,:\s@"]+(\.[^<>()[\]\\.,:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!email || !re.test(email)) {
    return false;
  }
  return true;
}
export function deleteCookie(name) {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}
export function getLSAuth() {
  const loggedInDataStr = localStorage.getItem("session_details");
  const loggedInData = loggedInDataStr ? JSON.parse(loggedInDataStr) : {};
  return loggedInData;
}
export const convertBytesToSize = (bytes) => {
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB"];
  const unit = 1024;
  if (bytes < unit) return bytes;
  if (bytes === 0) return "0 Byte";
  const exp = Math.floor(Math.log(bytes) / Math.log(unit));
  const result = bytes / unit ** exp;
  if (result / 100 < 1) return [parseFloat(result.toPrecision(3)), sizes[exp]];
  return [parseFloat(result.toPrecision(3)), sizes[exp]];
};
export const getMonthNames = () => [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
export const getMonthDateFormat = (date) => {
  const mmFormat = `0${date.getMonth() + 1}`.slice(-2);
  const ddFormat = `0${date.getDate()}`.slice(-2);
  return date ? `${date.getFullYear()}-${mmFormat}-${ddFormat}` : null;
};
export const getDatePeriodFormat = (startDate, endDate) => {
  const firstDay = startDate;
  const lastDay = endDate;
  const currentFromDateFormat = getMonthDateFormat(firstDay);
  const currentToDateFormat = getMonthDateFormat(lastDay);
  return `${currentFromDateFormat}   -   ${currentToDateFormat}`;
};

export const getParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  name = name ? name.replace(/[[\]]/g, "\\$&") : "";
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);

  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

export const _d = {
  pluck: (array, key) => {
    const arr = array || [];
    return arr.map((o) => o[key]);
  },
};
export const isValidRegex = (regex) => {
  let isValid = true;
  try {
    new RegExp(regex);
  } catch (e) {
    isValid = false;
  }
  return isValid;
};
export const getDDMMYYYY = () => {
  let today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1; // January is 0!

  const yyyy = today.getFullYear();
  dd = dd < 10 ? `0${dd}` : dd;
  mm = mm < 10 ? `0${mm}` : mm;
  return (today = `${dd}/${mm}/${yyyy}`);
};
export const getYYYMMDD = (date) => {
  const d = new Date(date);

  let month = `${d.getMonth() + 1}`;

  let day = `${d.getDate()}`;

  const year = d.getFullYear();

  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;

  return [year, month, day].join("-");
};
// export const arrayToObject = (array, keyField) =>
//   array.reduce((obj, item) => {
//     obj[item[keyField]] = item;
//     return obj;
//   }, {});
export const arrayToObject = (array = [], keyField) => {
  // Ensure array is an array before calling reduce
  if (!Array.isArray(array)) {
    console.error("arrayToObject error: input is not an array", array);
    return {};
  }

  return array.reduce((obj, item) => {
    obj[item[keyField]] = item;
    return obj;
  }, {});
};

export const capitalizeFLetter = (str) => {
  const strings = str.split(" ");
  return strings
    .map((string) => string[0].toUpperCase() + string.slice(1))
    .join(" ");
};

export const changeGroupName = (str) =>
  capitalizeFLetter(str.toLowerCase().split("_").join(" "));

export const getBefore90days = (date) => {
  const before90days = new Date(date);
  before90days.setDate(before90days.getDate() - 90);

  const format = new Date(before90days);

  let month = `${format.getMonth() + 1}`;

  let day = `${format.getDate()}`;

  const year = format.getFullYear();

  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;

  return [year, month, day].join("-");
};

export const getAfterStartDate = (date) => {
  const afterStartDate = new Date(date);
  afterStartDate.setDate(afterStartDate.getDate() + 1);

  const format = new Date(afterStartDate);

  let month = `${format.getMonth() + 1}`;

  let day = `${format.getDate()}`;

  const year = format.getFullYear();

  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;

  return [year, month, day].join("-");
};

export const hasActiveCustomBillingRate = (accountDetails) => {
  const currentDate = new Date();
  let accountActivate = false;
  if (accountDetails) {
    return accountDetails.some((item) => {
      if (
        new Date(item.startDate.value).setHours(0, 0, 0, 0) <=
          currentDate.setHours(0, 0, 0, 0) &&
        (item.endDate.value == null ||
          new Date(item.endDate.value).setHours(0, 0, 0, 0) >=
            currentDate.setHours(0, 0, 0, 0))
      ) {
        accountActivate = true;
      }
      return accountActivate;
    });
  }
  return accountActivate;
};
/* istanbul ignore next */
export const convertDateFormater = (date) => {
  const sArr = date.split("-").map((val) => Number(val));
  const currDate = new Date(sArr[2], sArr[0] - 1, sArr[1]);
  const dateFormat = `${`0${currDate.getMonth() + 1}`.slice(
    -2,
  )}-${currDate.getFullYear()}`;
  return dateFormat;
};
/* istanbul ignore next */
export const hasActiveRates = (billingData) => {
  const currentDate = new Date();
  const billingRate = {};
  const rate = 0;
  if (billingData) {
    billingData.map((item) => {
      if (
        new Date(item.startDate.value).setHours(0, 0, 0, 0) <=
          currentDate.setHours(0, 0, 0, 0) &&
        (item.endDate.value == null ||
          new Date(item.endDate.value).setHours(0, 0, 0, 0) >=
            currentDate.setHours(0, 0, 0, 0))
      ) {
        const formatter = new Intl.NumberFormat("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
        billingRate.expiration = item.endDate.value;
        billingRate.collection = formatter.format(item.collection.value);
        billingRate.connection = formatter.format(item.connection.value);
        billingRate.unitRate = item.unitRate.value;
      }
      return billingRate;
    });
  }
  return billingRate;
};
export function validateNumber(number) {
  const re = /^[+-]?\d+$/;
  if (!number || !re.test(number)) {
    return false;
  }
  return true;
}
